import { Address } from "./address";
import { BaseProperties } from "./base.interface";
import { CustomersOutput } from "./customers";
import { PaymentsOutput } from "./payments";
import { TagsOutput } from "./tags";

export enum OrderStatus {
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
  IN_PREPARATION = "IN_PREPARATION",
  PREPARED = "PREPARED",
  DONE = "DONE",
  CANCELED = "CANCELED",
}

export enum OrderDeliveryType {
  DELIVERY = "DELIVERY",
  WITHDRAWAL = "WITHDRAWAL",
}

export enum OrderPaymentStatus {
  PAID = "PAID",
  PENDING = "PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
}

export interface OrderDelivery {
  deliveryType: OrderDeliveryType;
  deliveryAt?: Date;
  deliveryValue?: number;
  address?: Address;
}

export interface OrderProductAdditionalInput {
  itemId: string;
  quantity: number;
}

export interface OrderProductAdditionalOutput
  extends OrderProductAdditionalInput {
  label: string;
  unitPrice: number;
  unitCost: number;
  consumptionFactor?: number;
}

export interface OrderProductInput {
  productId: string;
  quantity: number;
  observation?: string | null;
  additionals?: OrderProductAdditionalInput[];
}

export interface OrderProductOutput
  extends Omit<OrderProductInput, "additionals"> {
  name: string;
  unitCost: number;
  unitPrice: number;
  additionals?: OrderProductAdditionalOutput[];
}

export interface OrderInput {
  customerId?: string;
  customer?: string;
  products?: OrderProductInput[];
  status: OrderStatus;
  preparationDate: Date;
  orderDate: Date;
  delivery: OrderDelivery;
  tags?: string[];
  additional?: number;
  discount?: number;
  /** Valor de imposto calculado automaticamente */
  tax?: number;
  description?: string;
  totalAmount?: number;
}

export interface OrderOutput
  extends Omit<OrderInput, "customer" | "products" | "tags">,
    BaseProperties {
  id: string;
  customer: string | CustomersOutput;
  products: OrderProductOutput[];
  tags: TagsOutput[] | string[];
  paymentStatus: OrderPaymentStatus;
  payments: PaymentsOutput[];
  additional: number;
  discount: number;
  tax?: number;
  totalAmount: number;
}

export const orderDeliveryTypeTransalation: Record<OrderDeliveryType, string> =
  {
    [OrderDeliveryType.DELIVERY]: "Entrega",
    [OrderDeliveryType.WITHDRAWAL]: "Retirada",
  };

export const orderStatusTranslation: Record<OrderStatus, string> = {
  [OrderStatus.PENDING]: "Pendente",
  [OrderStatus.SCHEDULED]: "Agendado",
  [OrderStatus.IN_PREPARATION]: "Em preparação",
  [OrderStatus.PREPARED]: "Pronto",
  [OrderStatus.DONE]: "Entregue",
  [OrderStatus.CANCELED]: "Cancelada",
};

export const orderPaymentStatusTranslation: Record<
  Partial<OrderPaymentStatus>,
  string
> = {
  [OrderPaymentStatus.PENDING]: "Pendente",
  [OrderPaymentStatus.PARTIALLY_PAID]: "Parcialmente pago",
  [OrderPaymentStatus.PAID]: "Pago",
};

export interface OrdersQueryParams {
  customerId?: string;
  status?: OrderStatus;
  paymentStatus?: OrderPaymentStatus | OrderPaymentStatus[];
  deliveryType?: OrderDeliveryType;
  tags?: string[];
  startOrderDate?: string;
  endOrderDate?: string;
  minTotalAmount?: number | null;
  maxTotalAmount?: number | null;
  expand?: string[];
  page?: number;
  pageSize?: number;
}
